import { createSlotRecipe } from './runtime.js';

const commandMenuConfig = {"name":"commandMenu","slots":["content","header","input","list","empty","item","leftGroup","icon","title","subtitle","description"],"variantMap":{"active":["true"]}}

export const commandMenu = /* @__PURE__ */ createSlotRecipe(commandMenuConfig)